interface BadgeStatusProps {
  value: boolean;
}

export default function BadgeStatus({ value }: BadgeStatusProps) {
  const bgColor = value
    ? "border border-green-200 bg-green-50 text-green-700"
    : "border border-gainsboro bg-whisper text-txtBody";

  return (
    <span
      className={`px-2 py-1 rounded-lg font-semibold text-xs overflow-visible ${bgColor}`}
    >
      {value ? "Published" : "Unpublished"}
    </span>
  );
}
